import { FilterItem, knowledgeBaseItem } from 'models';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SupportSearchAction from 'redux/actions/supportSearchAction';
import { RootState } from 'redux/store';
import { useLanguageCode } from './useLanguageCode';
import useSupportSearch from './useSupportSearch';
import { useUserData } from './useUserData';

export const useKnowledgeFilter = (active = true) => {
  const { t } = useTranslation('getSupportSearch');

  const location = useLocation();

  const userData = useUserData();
  const languageCode = useLanguageCode();
  const { filterUndefinedCategoryItems } = useSupportSearch();

  const dispatch = useDispatch();
  const { listKBaseFilters, listCategoryFilters, kbListId } = useSelector(
    (state: RootState) => state.supportSearchReducer,
  );
  const { version, kbList, filterTrailingPart } = useSelector((state: RootState) => state.configReducer).generalConfig;
  const hasFilterTrailingPart = filterTrailingPart ?? true;

  useEffect(() => {
    try {
      if (!version) return;
        const listId = kbList.map((kb: knowledgeBaseItem) => kb.id);
        dispatch(SupportSearchAction.setKbListId(listId));
      } catch (error) {
        console.error(error);
      }
  }, [version]);

  useEffect(() => {
    if (!userData?.user_name || !active) return;

    const params = queryString.parse(location.search, {
      arrayFormat: 'comma',
    });
    const payload = {
      keyword: params?.q || '',
      user_name: userData.user_name,
      knowledge_bases: params?.knowledge_base || kbListId,
      categories: params?.category || [],
      language: languageCode.snow,
    };

    dispatch(SupportSearchAction.getKnowledgeBaseAndCategoryFilter(payload));
  }, [languageCode.snow, userData?.user_name, kbListId, active, location.search]);

  const mapCategoriesLabel = (categories: any[]) => {
    const kbLabels = (listKBaseFilters as any[]).reduce((labels, cur) => {
      return {
        ...labels,
        [cur.id]: cur.label,
      };
    }, {});

    return filterUndefinedCategoryItems(categories).map(category => ({
      ...category,
      label: `${hasFilterTrailingPart ? `${kbLabels[category.parent_id]} > ` : ''}${category.label}`,
    }));
  };

  const knowledgeFilter: FilterItem[] = [
    {
      label: t('knowledgeBase'),
      childs: listKBaseFilters,
      multiple: true,
      keyName: 'knowledge_base',
    },
    {
      label: t('category'),
      childs: mapCategoriesLabel(listCategoryFilters),
      multiple: true,
      keyName: 'category',
    },
  ];

  return { knowledgeFilter };
};
